import {
  Spinner,
  logger,
  useConstant,
  useCurrenciesContext,
  useIntlContext,
  useSecuritiesContext,
  useWLCustomerMarketAccountContext,
  useWLCustomerUserConfigContext,
  useWLOrgConfigContext,
  useWLUserContext,
  useWLUsersContext,
} from '@talos/kyoko';
import { useEffect, useState, type PropsWithChildren } from 'react';
import { useHomeBalanceContext } from './GCashHomeBalanceContext';

export const ProvidersGate = ({ children }: PropsWithChildren) => {
  const { isLoaded: isCurrenciesReady } = useCurrenciesContext();
  const { isLoaded: isSecuritiesReady } = useSecuritiesContext();
  const { isLoaded: isConfigReady } = useWLCustomerUserConfigContext();
  const { isLoaded: isUserReady } = useWLUserContext();
  const { isLoaded: isCustomerConfigReady } = useWLOrgConfigContext();
  const { isLoaded: isIntlReady } = useIntlContext();
  const { isLoaded: isUsersLoaded } = useWLUsersContext();
  const { isLoaded: isMarketAccountsLoaded } = useWLCustomerMarketAccountContext();
  const { isLoaded: isHomeBalanceReady } = useHomeBalanceContext();
  const [providersReady, setProvidersReady] = useState(false);
  const [disconnected, setDisconnected] = useState(false);

  useEffect(() => {
    setProvidersReady(
      isCurrenciesReady &&
        isSecuritiesReady &&
        isCustomerConfigReady &&
        isConfigReady &&
        isUserReady &&
        isIntlReady &&
        isUsersLoaded &&
        isMarketAccountsLoaded &&
        isHomeBalanceReady
    );
  }, [
    isCurrenciesReady,
    isSecuritiesReady,
    isCustomerConfigReady,
    isConfigReady,
    isUserReady,
    isIntlReady,
    isUsersLoaded,
    isMarketAccountsLoaded,
    isHomeBalanceReady,
  ]);

  const firstRenderTimeStamp = useConstant(Date.now());
  useEffect(() => {
    if (providersReady) {
      logger.trackDuration('ProvidersGate', {
        startTime: firstRenderTimeStamp,
        duration: Date.now() - firstRenderTimeStamp,
      });
    }
  }, [providersReady, firstRenderTimeStamp]);

  useEffect(() => {
    const ready = providersReady;
    const timeout = setTimeout(
      () => {
        setDisconnected(!ready);
        if (!ready) {
          logger.warn('[pg] Providers not ready within timeout');
        }
      },
      2 * 60 * 1000
    );
    return () => {
      clearTimeout(timeout);
    };
  }, [providersReady]);

  return providersReady ? (
    children
  ) : (
    <>{disconnected ? <div style={{ placeSelf: 'center', margin: '0 auto' }}>Disconnected!</div> : <Spinner />}</>
  );
};
